import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=4747f3dd&"
import script from "./ProductListItem.vue?vue&type=script&lang=js&"
export * from "./ProductListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports